import { defineComponent as _defineComponent } from 'vue'
import { onBeforeMount, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { AuthPage, type MaintenanceNotification, useAuthStore } from '@/stores/auth'
import LoginForm from '@/auth/components/LoginForm.vue'
import ForgotPasswordForm from '@/auth/components/ForgotPasswordForm.vue'
import TwoFactorAuthentication from '@/auth/components/TwoFactorAuthentication.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginPage',
  props: {
    maintenanceNotification: null
  },
  setup(__props: any) {

const props = __props as {
  maintenanceNotification: MaintenanceNotification | null
};



const {
  page,
  maintenanceNotification: maintenanceNotificationRef
} = storeToRefs(useAuthStore())

onBeforeMount(() => {
  maintenanceNotificationRef.value = props.maintenanceNotification

  // Remove the placeholder
  document.querySelector('#login-placeholder')?.remove()
})

onMounted(() => {
  // show the login page
  document.querySelector('#login-page')?.classList?.remove('d-none')
})

return { __sfc: true,props, page, maintenanceNotificationRef, AuthPage, LoginForm, ForgotPasswordForm, TwoFactorAuthentication }
}

})